import { datadogRum } from '@datadog/browser-rum';
import { useLocation } from '@ksyos/router';
import { useEffect } from 'react';

export function trackPageView(pathname?: string) {
    datadogRum.addAction('trackPageView', {
        pathname: pathname,
    });
}

export function addTrackEvent(category: string, action: string, name: string) {
    datadogRum.addAction(`trackEvent ${name}`, {
        action,
        category,
    });
}

export function addFormAnalytics(formNode?: HTMLFormElement | null, saveSendButtonNode?: HTMLButtonElement | null) {
    if (!formNode || !saveSendButtonNode) {
        return;
    }

    datadogRum.addAction('formAnalytics', {
        formNode,
        saveSendButtonNode,
    });

    trackPageView();
}

export function addTrackFormSubmit(saveSendButtonNode?: HTMLButtonElement | null) {
    if (!saveSendButtonNode) {
        return;
    }

    datadogRum.addAction('formSubmit', {
        saveSendButtonNode,
    });

    trackPageView();
}

export function addFormConversion(formNode?: HTMLFormElement | null) {
    if (!formNode) {
        return;
    }

    datadogRum.addAction('formConversion', {
        formNode,
    });

    trackPageView();
}

// Hooks
export function useAnalyticsPageView() {
    const { pathname } = useLocation();

    useEffect(() => {
        trackPageView();
    }, [pathname]);
}
